export default __webpack_public_path__ + "static/media/Empty.1127e9b4.gif";